/*! Solva Pillow PDP hero — qty stepper, gallery slider, sticky ATC reveal */
(function(){
  if (typeof document === 'undefined') return;

  /* ---- quantity steppers ---- */
  document.querySelectorAll('.solva-phero__qty').forEach(function(q){
    var input = q.querySelector('input');
    if (!input) return;
    q.querySelectorAll('[data-qty]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var v = parseInt(input.value || 1, 10);
        v = btn.getAttribute('data-qty') === 'plus' ? v + 1 : Math.max(1, v - 1);
        input.value = v;
      });
    });
  });

  /* ---- gallery slider: arrows, swipe, synced thumbs ---- */
  function initGallery(gallery){
    var track = gallery.querySelector('[data-gallery-track]');
    if (!track) return;
    if (gallery.dataset.galleryReady === '1') return;
    gallery.dataset.galleryReady = '1';

    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-gallery-slide]'));
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-solva-gallery-thumb]'));
    var prev = gallery.querySelector('[data-gallery-prev]');
    var next = gallery.querySelector('[data-gallery-next]');
    var count = slides.length;
    if (count < 1) return;

    var index = 0;

    function centerThumb(i){
      var btn = thumbs[i];
      if (!btn) return;
      var rail = btn.parentNode;
      if (!rail || rail.scrollWidth <= rail.clientWidth) return;
      var target = btn.offsetLeft - (rail.clientWidth - btn.offsetWidth) / 2;
      rail.scrollTo({ left: Math.max(0, target), behavior: 'smooth' });
    }

    function render(animate){
      if (!animate) track.style.transition = 'none';
      track.style.transform = 'translateX(' + (-index * 100) + '%)';
      if (!animate) { void track.offsetWidth; track.style.transition = ''; }
      thumbs.forEach(function(t, i){ t.classList.toggle('is-active', i === index); });
      if (prev) prev.disabled = index === 0;
      if (next) next.disabled = index === count - 1;
      centerThumb(index);
    }

    function goTo(i){
      index = Math.max(0, Math.min(count - 1, i));
      render(true);
    }

    if (prev) prev.addEventListener('click', function(){ goTo(index - 1); });
    if (next) next.addEventListener('click', function(){ goTo(index + 1); });
    thumbs.forEach(function(t, i){ t.addEventListener('click', function(){ goTo(i); }); });

    gallery.addEventListener('keydown', function(e){
      if (e.key === 'ArrowLeft') goTo(index - 1);
      if (e.key === 'ArrowRight') goTo(index + 1);
    });

    /* finger-follow swipe with axis detection */
    var startX = 0, startY = 0, dx = 0, width = 1;
    var dragging = false, decided = false, horizontal = false;

    track.addEventListener('touchstart', function(e){
      if (count < 2) return;
      dragging = true; decided = false; horizontal = false; dx = 0;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      width = track.offsetWidth || 1;
    }, { passive: true });

    track.addEventListener('touchmove', function(e){
      if (!dragging) return;
      var ddx = e.touches[0].clientX - startX;
      var ddy = e.touches[0].clientY - startY;
      if (!decided) {
        if (Math.abs(ddx) < 6 && Math.abs(ddy) < 6) return;
        decided = true;
        horizontal = Math.abs(ddx) > Math.abs(ddy);
        if (horizontal) track.style.transition = 'none';
      }
      if (!horizontal) return;
      dx = ddx;
      track.style.transform = 'translateX(' + ((-index * 100) + (dx / width * 100)) + '%)';
    }, { passive: true });

    track.addEventListener('touchend', function(){
      if (!dragging) return;
      dragging = false;
      if (!horizontal) return;
      track.style.transition = '';
      var threshold = width * 0.15;
      if (dx <= -threshold) index = Math.min(count - 1, index + 1);
      else if (dx >= threshold) index = Math.max(0, index - 1);
      render(true);
      dx = 0;
    }, { passive: true });

    render(false);
  }

  function initAll(root){
    var scope = root && root.querySelectorAll ? root : document;
    Array.prototype.slice.call(scope.querySelectorAll('[data-solva-gallery]')).forEach(initGallery);
  }
  initAll();
  document.addEventListener('shopify:section:load', function(e){ initAll(e.target); });

  /* ---- sticky ATC: AJAX add so the UpCart drawer opens ---- */
  document.addEventListener('submit', function(e){
    var form = e.target && e.target.closest ? e.target.closest('.solva-phero__sticky-form, .solva-poff__form') : null;
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[name="add"]');
    if (btn) {
      if (btn.dataset.loading === '1') return;
      btn.dataset.loading = '1';
      btn.disabled = true;
    }
    fetch('/cart/add.js?upcart=1', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    })
      .then(function(r){ return r.json().then(function(d){ return { ok: r.ok, d: d }; }); })
      .then(function(res){
        if (btn) { btn.disabled = false; delete btn.dataset.loading; }
        if (!res.ok) { form.submit(); return; }
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: res.d }));
      })
      .catch(function(){ if (btn) { btn.disabled = false; } form.submit(); });
  });

  /* ---- sticky ATC reveal (mobile + desktop) ---- */
  (function(){
    var bar = document.querySelector('[data-solva-stickybar]');
    var hero = document.querySelector('.solva-phero');
    if (!bar || !hero) return;
    var tick = false;
    function upd(){
      var r = hero.getBoundingClientRect();
      bar.classList.toggle('is-visible', r.bottom < window.innerHeight * 0.4);
      tick = false;
    }
    window.addEventListener('scroll', function(){ if(!tick){ requestAnimationFrame(upd); tick=true; } }, {passive:true});
    upd();
  })();
})();
